export default function SvgMark1() {
    return (
      <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10px"
        fill="#00cc00"
        viewBox="0 0 1920 1920"
       >
        <path
        fillRule="evenodd"
        d="M960 0C430.645 0 0 430.645 0 960s430.645 960 960 960 960-430.645 960-960S1489.355 0 960 0"
        ></path>
     </svg>
    </>
    );
  }
  